export const xs = '360px';
export const sm = '640px';
export const md = '768px';
export const lg = '1024px';
export const xl = '1280px';
